module.exports = __webpack_public_path__ + "static/img/product_images_big32_h5_zh.aebfd65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_big32_h5_zh.png
// module id = DGbB
// module chunks = 34